const ProjectUserFields = ({ projects, onChangeHandler, selectedProjects }) => (
  <div className="form-group">
    <label htmlFor="project_ids" className="control-label">Grant access to the following projects</label>
    <Select options={ projects }
      onChange={ onChangeHandler }
      isMulti={ true }
      value={ selectedProjects }
      name="project_ids"
      delimiter=","
    />
  </div>
)

ProjectUserFields.propTypes = {
  onChangeHandler: PropTypes.func.isRequired,
  selectedProjects: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired
  })).isRequired,
  projects: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired
  })).isRequired
}

export default ProjectUserFields



// WEBPACK FOOTER //
// ./app/javascript/reactFeatures/company-users/components/forms/ProjectUserFields.js